<template>
    <div>
        <button type="button"
            @click="geoLocate()"
            class="btn-white pr-2 pl-2 h-10"
            :class="buttonClass"
            :data-tooltip="tooltipText"
            aria-label="Click to search for shops near the city, state, or zip code you entered">
            <IconNavigation viewBox="0 0 24 24"
                class="inline-block w-5 h-5 text-blue mt-1"
                role="img"
                alt="An image of a navigation arrow"/>
        </button>
        <Modal ref="modal"
            :overlayClose="true"
            :overflow="false"
            :ariaLabelledBy="'modalTitle'"
            :ariaDescribedBy="'modalContent'">
            <div slot="title">
                <h2 id="modalTitle" class="text-lg md:text-xl">We do not have permission to use your location</h2>
            </div>
            <div slot="content">
                <div id="modalContent" class="max-w-md mb-6">
                    <p class="mt-3 mb-6 mx-6 sm:mx-12 md:mx-16 text-left">
                        Enable location permissions for this website in your browser settings.
                    </p>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/js/components/Modal.vue';
import IconNavigation from 'icon/navigation.svg';
import { mapActions } from 'vuex';
import router from '../router';

export default {
    props: {
        buttonClass: {
            type: String,
            required: false
        },
        tooltipText: {
            type: String,
            required: false
        }
    },
    components: {
        Modal,
        IconNavigation
    },
    methods: {
        ...mapActions('locations', [
            'selectGeoLocation',
            'setGeoLocationLoading'
        ]),
        geoLocate() {
            const { geolocation } = navigator;
            if (geolocation) {
                this.setGeoLocationLoading(true);
                geolocation.getCurrentPosition(
                    (position) => {
                        const location = {
                            address: null,
                            city: null,
                            state: null,
                            zip: null,
                            country: null,
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        };
                        this.selectGeoLocation(location);
                        if (this.$route.name !== 'shops') {
                            router.push('shops');
                        }
                    },
                    (error) => {
                        switch (error.code) {
                        case error.PERMISSION_DENIED:
                            this.$refs.modal.open();
                            break;
                        default:
                            // eslint-disable-next-line
                            console.error(error.message);
                        }
                    }
                );
            } else {
                this.$refs.modal.open();
            }
        }
    }
};
</script>
